/* global loadingBar, buildNumber, snackbar, lng */

/**
 * Contains some functions for netowrk requests.
 * @type type
 */
var Network = {
  /**
   * Simple and fast functon to perform a request to a server.
   * @param {String} url
   * Request url
   * @param {Object} data
   * Data to send to <i>url</i>
   * @param {Object} callbacks
   * Callback maping on http status codes. <br>
   * Example: <pre>
   * {
   *  200: function(response){
   *      //..
   *  },
   *  403: function(response){
   *      //..
   *  }
   * }</pre>
   * @param {Function} errorCB
   * Callback wich will be called on error.
   * @param {Function} doneCB
   * Callback wich will be called before <i>callback</i> or <i>errorCB</i>.
   * @param {Object} options
   * (optional)
   * Some http options
   * <ul>
   * <li><i>contentType</i> Default is <i>application/x-www-form-urlencoded</i> </li>
   * <li><i>requestMethod</i> Http request type. Default is <i>POST</i>.</li>
   * </ul>
   * @returns {XMLHttpRequest}
   */
  request: function (url, data, callbacks, errorCB, doneCB, options) {
    loadingBar.push();

    if (typeof options === "undefined") options = {};
    if (options.contentType === undefined)
      options.contentType = "application/x-www-form-urlencoded";

    /* ---- config start ---- */

    /**
     * If true, send and receive data will be logged in console.
     * @type Boolean
     */
    var DEBUG = false;

    /* ---- config end ---- */

    if (typeof options.requestMethod === "undefined")
      options.requestMethod = "GET";

    //create new http request
    var xhr = new XMLHttpRequest();
    xhr.open(options.requestMethod, url, true);
    xhr.setRequestHeader("Content-type", options.contentType);

    //catch errors
    xhr.onerror = function () {
      if (typeof doneCB === "function") doneCB();
      if (typeof errorCB === "function") errorCB();

      loadingBar.pop();
    };
    xhr.onabort = xhr.onerror;
    xhr.ontimeout = xhr.onerror;

    //receive data
    xhr.onreadystatechange = function () {
      //wait for request ist done
      if (xhr.readyState !== XMLHttpRequest.DONE) return;

      //uncaught http status code
      if (callbacks[xhr.status] === undefined) return xhr.onerror();

      //everything ok
      var response = xhr.responseText;

      //debug logging
      if (DEBUG) {
        console.log(options.requestMethod + "(" + url + "):");
        if (url.indexOf(".html") === -1) {
          console.log(data);
          console.log("response:");
          console.log(response);
        }
      }

      if (typeof doneCB === "function") doneCB();

      //get callback by http status code
      var callback = callbacks[xhr.status];
      if (typeof callback === "function") callback(response);

      loadingBar.pop();
    };

    //send data
    xhr.send(data);

    return xhr;
  },
  /**
   * Simple and fast functon to perform an API request to a server.
   * Uses <i>_encodePost</i> and <i>_decodeResponse</i> to prepare request and response data.
   * @param {String} api
   * Function to be called on server.
   * example: "Class.Function"
   * @param {Object} data
   * Data to call the <i>api</i> function.
   * @param {Object} callbacks
   * Callback maping on http status codes. <br>
   * Example: <pre>
   * {
   *  200: function(response){
   *      //..
   *  },
   *  403: function(response){
   *      //..
   *  }
   * }</pre>
   * @param {Function} errorCB
   * Callback wich will be called on error.
   * @param {Function} doneCB
   * Callback wich will be called before <i>callback</i> or <i>errorCB</i>.
   * @param {String} requestMethod
   * (optional) Default: <i>POST</i>.
   * Type of http request method. For example: POST, GET, PUT, DELETE,..
   * @returns {XMLHttpRequest}
   */
  apiRequest: function (api, data, callbacks, errorCB, doneCB, requestMethod) {
    /* ---- config start ---- */

    /**
     * Set the path to your API here.
     * @type String
     */
    var API_PATH = "api/api.php";

    //To config send and recieve data, see _encodePost() and _decodeResponse().

    /**
     * Some options for <i>request()</i>
     * @type Object
     */
    var requestOptions = {
      requestMethod: requestMethod ? requestMethod : "POST", //post is default
      contentType: "application/x-www-form-urlencoded",
    };

    /* ---- config end ---- */

    //add decode to response for each success callback
    var cbGen = function (cb) {
      return function (response) {
        cb(_decodeResponse(response));
      };
    };
    for (var i in callbacks) callbacks[i] = cbGen(callbacks[i]);

    //send request
    return this.request(
      API_PATH,
      this._encodePost(api, data),
      callbacks,
      errorCB,
      doneCB,
      requestOptions
    );
  },
  /**
     * Create an Object that can be send to the API. The format of the build
     * string is: <br>
     * {
     f: target,
     data: data,
     build: buildNumber
     }
     * @param {string} target
     * example: "Class.Function"
     * @param {object} data
     * @returns {string}
     * <i>application/x-www-form-urlencoded</i> string.
     */
  _encodePost: function (target, data) {
    var result = {
      f: target,
      data: data,
      build: buildNumber,
    };
    return encode(result);

    /**
     * Convert object to urlencoded string
     * @param {objet} data
     * @param {string} _prefix
     * Only for recursive call
     * @returns {String}
     */
    function encode(data, _prefix) {
      var str = [];
      for (var i in data) {
        var key = _prefix ? _prefix + "[" + i + "]" : i,
          value = data[i];
        if (typeof value === "object")
          //recursive call
          str.push(encode(value, key));
        else
          str.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
      }
      return str.join("&");
    }
  },
  /**
   * Decode the response of a post from the API to an object.
   * As it is postResponse is an JSON. PHP Warnings and Errors will be
   * logged on console. If valid JSON follows the Errors, response will be parsed.
   * @param {string} postResponseP
   * Response string from the API.
   * This function expects the response has the key <i>code</i> in it.
   * This will be parsed to int.
   * @returns {object}
   */
  _decodeResponse: function (postResponseP) {
    var postResponse = postResponseP;

    //check if server does some output before json
    var i = postResponse.indexOf("{");
    switch (i) {
      case -1:
        //expected json not found
        console.error(
          "%cServer send\n%c" + postResponse,
          "color: #009900;",
          "color: #990000;"
        );
        return {
          code: -1,
          msg: "Response from Server not valid.",
        };
        break;
      case 0:
        //everything ok
        break;
      default:
        //PHP thows error. JSON is following, because of i !== -1
        console.warn(
          "%cPHP output\n%c" + postResponse.substring(0, i),
          "color: #009900;",
          "color: #990000;"
        );
        //remove additional server output and continue
        postResponse = postResponse.substring(i);
    }

    //try to parse json
    try {
      postResponse = JSON.parse(postResponse);
    } catch (e) {
      console.error("Response from Server not a valid JSON");
      console.log(postResponseP);
      return {
        code: -1,
        msg: "Response from Server not a valid JSON",
      };
    }

    //parse code to int for better switch case in future code
    postResponse.code = parseInt(postResponse.code);

    return postResponse;
  },
  /**
   * Sends an GET request to <code>url</code> and expects JSON.
   * @param {string} url
   * URL with GET data
   * @param {Function} callback
   * Callback wich will be called with recieved data on success.
   * @param {Function} errorCB
   * Callback wich will be called on error.
   * @param {Function} doneCB
   * Callback wich will be called before <i>success</i> or <i>errorCB</i>.
   * @returns {undefined}
   */
  getJSON: function (url, callback, errorCB, doneCB) {
    /* ---- config start ---- */

    /**
     * If true, send and receive data will be logged in console.
     * @type Boolean
     */
    var DEBUG = true;

    /* ---- config end ---- */

    /**
     * Some options for <i>request()</i>
     * @type Object
     */
    var requestOptions = {
      requestMethod: "GET", //get is default
      contentType: "application/x-www-form-urlencoded",
    };

    var reqestCallbacks = {
      200: function (reponse) {
        //http ok

        var result;

        //try to parse json
        try {
          result = JSON.parse(reponse);
        } catch (e) {
          console.error("Response from Server not a valid JSON");
          console.log(reponse);
          return null;
        }

        if (DEBUG) {
          //debug logging
          console.log("getJSON(" + url + ")");
          console.log("response:");
          console.log(result);
        }

        if (typeof callback === "function") callback(result);
      },
    };

    return this.request(
      url,
      null,
      reqestCallbacks,
      errorCB,
      doneCB,
      requestOptions
    );
  },
  openXHR: function (method, path) {
    var xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    xhr.open(method, path);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.onerror = () => snackbar.show({ message: lng.get("network-err") });
    return xhr;
  },
  generateErrMsg: function (xhr) {
    var result = `Code ${xhr.status}. `;

    switch (xhr.status) {
      case 404:
        result += "Objekt nicht gefunden.";
        break;
      case 403:
        result += "Zugriff verweigert";
        break;
      case 405:
        result += "Nicht erlaubt";
        break;
      case 0:
        result += lng.get("network-err");
        break;
      default:
        result += "Unbekannter Fehler";
    }

    return result;
  },
};
